import React, { ReactElement, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import BigTeaserArticleImage from '../../BigTeaser/Image/Article'
import { TeaserCaption } from '../Components'
import { LabelProps } from '../../../BaseComponents/Labels/Types'
import LinkProps from '../../../Link/LinkProps'

export type ArticleImageTeaserProps = {
    /** static width for the teaser */
    width?: number | string
    /** href string to navigate to the provided url (web only) */
    href?: string
    /**
     * callback when the user pressed on the component
     *
     * @TJS-type function
     */
    onPress?: () => void
    /** imageProps must contain url */
    imageUrl?: string
    /** info for seo about imageUrl */
    alt?: string
    /** caption text under the teaser */
    caption?: string
} & TestID &
    LinkProps &
    LabelProps

const ArticleImageTeaser = ({
    width = '100%',
    href,
    onPress,
    imageUrl,
    alt,
    caption,
    labels,
    testID,
    webRel,
}: ArticleImageTeaserProps): ReactElement => {
    return (
        <Grid noExpand horizontal width={width} testID={testID} backgroundColor="pearl">
            <Touchable onPress={onPress} href={href} expand webRel={webRel}>
                <Grid noExpand>
                    <BigTeaserArticleImage imageUrl={imageUrl} alt={alt} labels={labels} />
                    {caption ? <TeaserCaption caption={caption} /> : null}
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default memo(ArticleImageTeaser)
